import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d979fb10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content flex-cen" }
const _hoisted_2 = { class: "step-index" }

import Category from '@/components/bussiness/Category/Category.vue'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { continueOEM } from '@/util/useConfirm'
import { slideIn } from '@/util/useLoading'
import { sourcingOEMDetail } from '@/apis/oem'
import useMutate from '@/util/useMutate'
import createNode from './model/nodes'
import Process from './components/Process.vue'
import BranchOption from './components/BranchOption.vue'
import InfoForm from './components/InfoForm.vue'
import CompleteQuest from './components/CompleteQuest.vue'

// node会保存到本地，所以组件不能存在node中，先做映射的方式

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const components: any = {
  BranchOption,
  InfoForm,
  CompleteQuest
}

const store = useStore()
const { query } = useRoute()

const loading = ref(false)
const curNode: any = ref(null)
const records: any = ref([])
const last = computed(() => records.value[records.value.length - 1])
const data: any = computed(() =>
  records.value.reduce((acc: any, node: any) => Object.assign(acc, node.data), {
    ...query
  })
)
const step = computed(
  () => records.value.findIndex((v: any) => v === curNode.value) + 1
)
const [enter, leave] = slideIn(step)

const next = async (to: string | string[]) => {
  // 如果是分支节点，选择分支不一样则肯定重改
  let recreate = false
  console.log(data.value)
  if (typeof to !== 'string') {
    to = to[0]
    recreate = true
  }
  const nextNode = recreate ? null : records.value[step.value]
  loading.value = true
  if (to === nextNode?.id) {
    curNode.value = nextNode
  } else {
    records.value = records.value.slice(0, step.value)
    curNode.value = await createNode(
      to,
      curNode.value,
      data.value,
      records.value
    )
    records.value.push(curNode.value)
  }
  loading.value = false
}

// 验证当前节点表单信息
const pick = async (node: any) => {
  const isLast = curNode.value === last.value
  const valid = nodeRef.value.valid ?? (() => true)
  if (isLast || (await valid('当前页面信息填写完整后方可切换'))) {
    curNode.value = node
  }
}
const nodeRef: any = ref(null)

// 记录保存到本地
const setRecords = (get: any) =>
  useMutate(
    {
      get,
      commit: (val: any) =>
        query.searchSourceOrderId || store.commit('goods/oemRecords', val)
    },
    records,
    { deep: true }
  )

// 创建还是编辑OEM
if (query.searchSourceOrderId) {
  sourcingOEMDetail(query).then((res: any) => {
    if (res.success) {
      const records = JSON.parse(res.data?.searchSourceOrder?.questionRecord)
      setRecords(() => records)
      curNode.value = last.value
    }
  })
} else {
  const t = store.state.goods.oemRecords
  const isEnd = !t.length || t[t.length - 1]?.finish
  setRecords(() => (isEnd ? [] : t))
  if (records.value.length > 1) {
    curNode.value = last.value
    continueOEM(
      () => {},
      () => {
        records.value = []
        next('1')
      }
    )
  } else {
    next(['1'])
  }
}
const height = ref('')

return (_ctx: any,_cache: any) => {
  const _directive_resize = _resolveDirective("resize")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Category),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Process, {
        records: records.value,
        onPick: pick,
        node: curNode.value
      }, null, 8, ["records", "node"]),
      (_unref(step) > 0)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "question",
            style: _normalizeStyle({ height: height.value })
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_Transition, {
                "enter-active-class": _unref(enter),
                "leave-active-class": _unref(leave)
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("label", {
                    class: "flex-center",
                    key: _unref(step)
                  }, _toDisplayString(_unref(step)), 1))
                ]),
                _: 1
              }, 8, ["enter-active-class", "leave-active-class"])
            ]),
            _createVNode(_Transition, {
              "enter-active-class": _unref(enter),
              "leave-active-class": _unref(leave)
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(components[curNode.value.type]), {
                  class: "abs",
                  ref: (_value, _refs) => {
                    _refs['nodeRef'] = _value
                    nodeRef.value = _value
                  },
                  key: _unref(step),
                  node: curNode.value,
                  records: records.value,
                  data: _unref(data),
                  onNext: next
                }, null, 8, ["node", "records", "data"])), [
                  [_directive_resize, (rect)=>height.value=rect.height+60+'px']
                ])
              ]),
              _: 1
            }, 8, ["enter-active-class", "leave-active-class"])
          ], 4)), [
            [_directive_loading, loading.value]
          ])
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})